// extracted by mini-css-extract-plugin
export var settingsList = "_2l-0";
export var settingsRow = "_2l-1";
export var warningDot = "_2l-2";